import { render, staticRenderFns } from "./table-page.vue?vue&type=template&id=0f6e671b&scoped=true&"
import script from "./table-page.vue?vue&type=script&lang=js&"
export * from "./table-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e671b",
  null
  
)

export default component.exports